<h3 class="smaller" [ngClass]="{ 'mb-deci': subHeader }">
  {{ header | translate }}
  <img *ngIf="icon" [src]="icon"  alt=""/>
</h3>
<p class="small-light" [innerHTML]="subHeader | translate | removeWidows"></p>
